import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LanguageService } from "./../language.service";
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http'; // Importiere HttpClientModule

@Component({
  selector: 'app-about-me',
  standalone: true,
  imports: [
    CommonModule,
    HttpClientModule
  ],
  templateUrl: './about-me.component.html',
  styleUrl: './about-me.component.scss'
})
export class AboutMeComponent implements OnInit {
  aboutMeText: string = '';
  myOfferText: string = '';
  showTextOverlay: boolean = false;

  constructor(
    private languageService: LanguageService, 
    private http: HttpClient,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.languageService.getCurrentLanguage().subscribe(lang => {
      this.onLanguageChange(lang);
    });
  }
  
  onLanguageChange(lang: string): void {
    this.loadText(lang); 
  }

  loadText(lang: string): void {
    this.http.get<any>('assets/text-data.json').subscribe(data => {
      this.aboutMeText = data[lang]['aboutMe'];
      this.myOfferText = data[lang]['myOffer'];
    });
  }

  closeTextOverlay(event: Event) {
    // Schließt das Overlay nur, wenn außerhalb von `.overlay-content` geklickt wurde
    this.showTextOverlay = false;
  }
  
  toggleTextOverlay(event?: Event) {
    this.showTextOverlay = !this.showTextOverlay;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    // Überprüfen, ob der Klick außerhalb des text-frame-Bereichs erfolgt
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showTextOverlay = false;
    }
  }
}
